// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__ZyJBY","inputWrap":"CustomTip_inputWrap__1szU7"};